import React, { FC, Dispatch } from 'react';

import { Tabs, Tab } from '@mui/material';

interface Props {
  value: number;
  valueSetter: Dispatch<number>;
  titles: Array<string>;
}

export const TabBar: FC<Props> = ({ value, valueSetter, titles }) => {
  const handleChange = (_: never, newValue: number) => {
    valueSetter(newValue);
  };

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      indicatorColor="primary"
      textColor="primary"
      centered={true}
      sx={{
        marginTop: '45px',
        marginBottom: '-45px',
      }}
    >
      {titles.map((title) => (
        <Tab key={title} label={title} />
      ))}
    </Tabs>
  );
};
